module.exports = __webpack_public_path__ + "static/media/en.b6e5300d.svg";